import {Grid, Tabs} from "@mui/material";
import {useState} from "react";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import SignUpForm from "./SignUpForm";
import SignInForm from "./SignInForm";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Login = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Grid container direction="column" alignItems="center" justifyContent="center" spacing={3} style={{ minHeight: '100vh' }}>
            <Grid item>
                <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label="Prihlásenie" {...a11yProps(0)} />
                    <Tab label="Registrácia" {...a11yProps(1)} />
                </Tabs>
            </Grid>
            <Grid item>
                <TabPanel value={tabValue} index={0}>
                    <SignInForm />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <SignUpForm />
                </TabPanel>
            </Grid>
        </Grid>
    );
}

export default Login;